import React, { useState } from 'react';
import { ImpFlex, ImpContainer, ImpText, ImpPad, ImpIcon, Icons, colors, } from '../..';
import styled, { css } from 'styled-components';
import { ANIMATION_DURATION } from '../../DesignSystem/design-system';
const Container = styled(ImpContainer) `
  border-radius: 12px;
  border: 1px solid;
  transition: ${ANIMATION_DURATION} all;
  background-color: white;

  ${({ selected, useMerchantColor }) => {
    if (selected) {
        return css `
        border-color: ${useMerchantColor
            ? 'var(--merchant-color)'
            : colors.border.borderFocus};
        box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
      `;
    }
    else {
        return css `
        border-color: ${colors.border.borderVariant};

        &:hover {
          background-color: ${colors.surface.surfaceMid};
        }
      `;
    }
}}

  &:active {
    background-color: ${colors.surface.surfaceLow};
  }
`;
function ImpDetailedSelect({ items, useMerchantColor = false, onSelect, }) {
    const [selectedButton, setselectedButton] = useState(-1);
    const handleOnClick = (index) => {
        setselectedButton(index);
    };
    return (React.createElement(ImpFlex, { direction: "column", gap: "s", dataTestId: "detailed-list" }, items.map((item, index) => (React.createElement(Container, { key: index, dataTestId: "detailed-item-container", selected: selectedButton === index, useMerchantColor: useMerchantColor, height: "100%", width: "100%", onClick: () => {
            handleOnClick(index);
            onSelect && onSelect(index);
        } },
        React.createElement(ImpPad, { padding: "24px", mobilePadding: "16px", dataTestId: "detailed-item-pad" },
            React.createElement(ImpFlex, { direction: "row", align: "center", gap: "l", fluid: true },
                React.createElement(ImpIcon, { size: '24px', stroke: useMerchantColor
                        ? 'var(--merchant-color)'
                        : colors.content.onBackground, iconSrc: selectedButton === index ? Icons.radioSelected : Icons.radio }),
                React.createElement(ImpFlex, { direction: "column" },
                    React.createElement(ImpText, { typography: "body1", dataTestId: "detailed-item-title" }, item.title),
                    selectedButton === index && item.subtitle !== '' && (React.createElement(ImpText, { typography: "body2", color: colors.content.onBackgroundVariant }, item.subtitle))))))))));
}
export default ImpDetailedSelect;
//# sourceMappingURL=ImpDetailedSelect.js.map